import '@gracile/gracile/hydration-elements';

// NOTE: Client side router disabled for now.
export const router = new EventTarget();
